import React from "react";

const Logo = () => {
  return (
    <div className="logo">
      <img src="/src/img/Oversize.png" alt="Логотип AGYM Oversize" />
    </div>
  );
};

export default Logo;
